import { Modal } from 'antd';

const confirmDanger = (title, okText, onOk) =>
	Modal.confirm({ title, okText, okButtonProps: { danger: true }, onOk });

export default confirmDanger;
